import script from "./UiPill.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiPill.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./UiPill.vue?vue&type=style&index=0&id=5836af74&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__